<template>
  <div class="toast-container">
    <transition-group name="toast-fade" tag="div">
      <v-alert
        v-for="toast in activeToasts"
        :key="toast.id"
        :type="toast.type"
        :value="true"
        :dismissible="toast.dismissible"
        :color="toast.type === 'success' ? 'accent' : toast.type"
        close-icon="close"
        @input="removeToast(toast.id)"
        class="mb-3 toast"
        border="left"
      >
        <div class="d-flex flex-column">
          <strong v-if="toast.title" class="toast-title">{{ getTranslation(toast.title) }}</strong>
          <span v-if="toast.content" class="toast-content">{{ getTranslation(toast.content) }}</span>
          <v-btn
            v-if="toast.action"
            small
            color="white"
            class="mt-2 align-self-start black--text"
            @click="handleAction(toast)"
          >
            {{ getTranslation(toast.action.text) }}
          </v-btn>
        </div>
        <v-progress-linear
          v-if="toast.timeout || (toast.timeout === undefined && toast.dismissible === false)"
          :key="`progress-${toast.id}-${toast.timeoutSetAt || 0}`"
          :value="toast.timeout ? 100 : undefined"
          :indeterminate="!toast.timeout"
          height="4"
          color="white"
          class="mt-2"
          :class="{ 'shrink-animation': toast.timeout }"
          :style="{ animationDuration: toast.timeout + 'ms' }"
        />
      </v-alert>
    </transition-group>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import { Toast } from '@/model/Toast';

export default Vue.extend({
  name: 'Toasts',
  computed: {
    ...mapState('toasts', {
      activeToasts: (state: any): Toast[] => state.toasts
    }),
  },
  methods: {
    ...mapActions('toasts', ['remove']),
    removeToast(toastId: number) {
      (this as any).remove(toastId);
    },
    handleAction(toast: Toast) {
      if (toast.action) {
        toast.action.callback();
      }
    },
    getTranslation(text: string): string {
      if (this.$te(text)) {
        return this.$t(text) as string;
      }
      return text;
    },
  },
});
</script>

<style lang="sass" scoped>
.toast-container
  position: fixed
  right: 1em
  top: 5em
  z-index: 200
  width: 100%
  max-width: 350px
  overflow-y: auto
  overflow-x: hidden

.toast-fade-enter-active,
.toast-fade-leave-active
  transition: opacity 0.3s ease, transform 0.3s ease

.toast-fade-enter,
.toast-fade-leave-to
  opacity: 0
  transform: translateX(30px)

.toast-fade-move
  transition: transform 0.3s ease

.toast-title
  font-weight: bold
  margin-bottom: 4px

.v-alert
  word-wrap: break-word
  word-break: break-word

.shrink-animation
  > :deep(.v-progress-linear__background)
    left: 0 !important
    width: 100% !important
  > :deep(.v-progress-linear__determinate)
    animation-name: shrink
    animation-fill-mode: forwards
    animation-iteration-count: 1
    animation-timing-function: linear
    animation-duration: inherit

.toast :deep(.v-alert__dismissible)
  align-self: flex-start
  margin: 0
</style>

<style lang="sass">
@keyframes shrink
  from
    width: 100%
  to
    width: 0%
</style>
